export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/advanced-feed-worker.ab222587.worker.js");
}
